export const SUBMIT_FEEDBACK = 'app/CommercialV2/ReviewPage/SUBMIT_FEEDBACK';
export const REVIEW_PAGE_LOADED = 'app/CommercialV2/ReviewPage/REVIEW_PAGE_LOADED';
